// Input gesture action types

export type InputPhase = "start" | "move" | "end" | "cancel";

export interface InputSample {
  x: number; // CSS/logical pixels
  y: number;
  t: number; // timestamp in milliseconds
  pointerId: number;
  phase: InputPhase;
}

export interface GatherStrokeAction {
  type: "gatherStroke";
  speed: number;
  tick: number;
}

export interface RollProgressAction {
  type: "rollProgress";
  radians: number;
}

export interface RollLapAction {
  type: "rollLap";
  tick: number;
  // Quality of the closed lap. A round lap of perfectMaxSeconds or less packs a
  // PERFECT PACK ball. Omitted means an ordinary lap.
  lapSeconds?: number;
  round?: boolean;
}

export interface ThrowAction {
  type: "throw";
  lane: "left" | "center" | "right";
  power: number; // 0..1, normalized velocity
  tick: number;
}

export interface DodgeAction {
  type: "dodge";
  direction: "left" | "right";
  tick: number;
}

export interface BlockAction {
  type: "block";
  tick: number;
}

export type InputAction =
  | GatherStrokeAction
  | RollProgressAction
  | RollLapAction
  | ThrowAction
  | DodgeAction
  | BlockAction;

export type InputListener = (action: InputAction) => void;

// Anti-cheat constants (exported for ghost validation)
export const MAX_GATHER_RATE = 12; // strokes per second
export const MAX_ROLL_RATE = 4; // laps per second
export const MAX_THROW_RATE = 5; // throws per second
